import { Route, Routes } from 'react-router-dom';
import EmailNotifications from './components/EmailNotifications';
import UserPermissionsContainer from './container/UserPermissionsContainer';
import AdminPermissionState from './context/AdminPermissionState';
import { Breadcrumb, Breadcrumbs } from '@digitools/honest-ui';
import { useHomePageBreadcrumbs } from 'src/components/Breadcrumbs';
import { getEnvVariable } from 'src/utils/envUtils';
const updatedEmployerEmailNotificationsEnabled = getEnvVariable('updatedEmployerEmailNotificationsEnabled');
const AdminRouter = () => {
    const breadCrumbTitle = () => {
        if (window.location.pathname.includes('/emailNotification')) {
            return 'E-mail Settings';
        }
        else if (window.location.pathname.includes('/permissions')) {
            return 'User Access';
        }
    };
    return (<>
      <Breadcrumbs>
        {useHomePageBreadcrumbs()}
        <Breadcrumb>{breadCrumbTitle()}</Breadcrumb>
      </Breadcrumbs>
      <AdminPermissionState>
        <Routes>
          {!updatedEmployerEmailNotificationsEnabled && (<Route path={`/emailNotification`} element={<EmailNotifications />}/>)}
          <Route path={`/permissions`} element={<UserPermissionsContainer />}/>
        </Routes>
      </AdminPermissionState>
    </>);
};
export default AdminRouter;
